import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Procedure } from '../models/Procedure';
@Component({
  selector: 'app-procedure',
  templateUrl: './procedure.component.html'
})
export class ProcedureComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Procedure'
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	  
	@Input() procedure : Procedure;

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

